var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tt-image-lazy"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.imgSrcLazy),expression:"imgSrcLazy"}],attrs:{"alt":_vm.altText}})])
}
var staticRenderFns = []

export { render, staticRenderFns }